// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1cDSq","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3LGPa"};